/* @flow */
export default ngModule => {
    ngModule.factory('ZohoService', function ($q, $state, $log, $http, AonApi, AonApplicationService, Auth) {

        const sanitizeApplicantData = applicant => {
            const sanitizedData = _.cloneDeep(applicant);

            // Check current products. When user clears a product field that previously contained a value,
            // the model gets set to the value of "" (empty string). Backend expects an object|null, so
            // convert it here.
            const hasEmptyCurrentHospital = _.get(sanitizedData, 'personal.previous_fund.hospital_product', null) === '';
            const hasEmptyCurrentAncillary = _.get(sanitizedData, 'personal.previous_fund.ancillary_product', null) === '';
            if (hasEmptyCurrentHospital) {
                _.set(sanitizedData, 'personal.previous_fund.hospital_product', null);
            }
            if (hasEmptyCurrentAncillary) {
                _.set(sanitizedData, 'personal.previous_fund.ancillary_product', null);
            }
            return sanitizedData;
        };

        class ZohoService {

            constructor() {
                this.apiError = null;
            }

            wrapApiCall(promise) {
                this.apiError = null;
                return promise.catch(error => {
                    const {data} = error;
                    console.error('Zoho API error:', error);
                    this.apiError = data;
                    throw error;
                });
            }

            getZohoApplicant(leadId, operatorName = null, add_note = null) {
                const payload = {type: 'get_lead' };
                if (add_note) {
                    payload.add_opportunity_note = add_note;
                }
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}`, payload)
                    .then((response) => {
                        if (response.data.valid) {
                            return AonApplicationService.getApplication().then((applicant) => {
                                const data = response.data;
                                const keys = [
                                    'personal.first_name',
                                    'personal.last_name',
                                    'personal.gender',
                                    'personal.dob',
                                    'personal.dob',
                                    'personal.previous_fund',
                                    'personal.vitality',
                                    'partner.title',
                                    'partner.first_name',
                                    'partner.last_name',
                                    'partner.gender',
                                    'partner.dob',
                                    'primary_address.state',
                                    'primary_address.address1',
                                    'contact.phone_mobile',
                                    'contact.email_address',
                                    'policy.lhc_age',
                                    'policy.held_continuous_hospital_cover',
                                    'policy.medicare.number',
                                    'policy.medicare.expiry',
                                    'policy.medicare.first_name',
                                    'policy.medicare.last_name',
                                    'policy.lhc_age_partner',
                                    'policy.federal_rebate',
                                    'policy.rebate_tier',
                                    'policy.motivation',
                                    'policy.motivation2',
                                    'policy.membership_type',
                                    'policy.primary_service_need',
                                    'policy.primary_youth_discount_age',
                                    'policy.partner_youth_discount_age',
                                    'policy.discount_code',
                                    'payment.frequency',
                                    'number_of_dependants',
                                    'dependants',
                                    'zoho.owner_name',
                                    'zoho.owner_first_name',
                                    'zoho.owner_email',
                                    'zoho.company',
                                    'zoho.company_id',
                                    'zoho.company_logo',
                                    'zoho.company_contact_number',
                                    'zoho.company_template',
                                    'zoho.company_error_template',
                                    'zoho.apply_corporate',
                                    'zoho.motivation',
                                    'zoho.motivation2',
                                    'zoho.has_quote',
                                    'zoho.rate_code',
                                    'zoho.quoted_product',
                                    'zoho.quoted_product_fund',
                                    'zoho.stage_is_closed',
                                    'zoho.advisor',
                                    'zoho.licensee',
                                    'zoho.expected_yearly_savings',
                                    'zoho.improved_benefit_1',
                                    'zoho.improved_benefit_2',
                                    'zoho.improved_benefit_3',
                                    'zoho.rebate_percent',
                                    'zoho.channel',
                                    'zoho.lead_category',
                                    'zoho.team_signature',
                                    'zoho.consultant_signature_line_1',
                                    'zoho.consultant_signature_line_2',
                                    'zoho.company_data',
                                    'zoho.promo_code',
                                    'zoho.cooling_off_applies',
                                    'zoho.cooling_off_period',
                                    'fund_specific_data',
                                    'quote_details.application_link',
                                    'quote_details.quote_link',
                                    'application_domains.public',
                                    'application_domains.agent'
                                ];

                                if (data.is_internal_record){
                                    applicant = data
                                }
                                else
                                    for (let key of keys) {
                                        _.set(applicant, key, _.get(data, key));
                                    }

                                applicant.zoho_id = leadId;
                                applicant.cmn_id = data.cmn_id;

                                // Save initial value for rebate-related fields
                                _.set(applicant, 'logging.initial.policy.lhc_age', data.policy.lhc_age);
                                _.set(applicant, 'logging.initial.policy.lhc_age_partner', data.policy.lhc_age_partner);
                                _.set(applicant, 'logging.initial.policy.federal_rebate', data.policy.federal_rebate);
                                _.set(applicant, 'logging.initial.policy.rebate_tier', data.policy.rebate_tier);

                                // If an operator name was passed in, store it
                                _.set(applicant, 'zoho.operator', operatorName);

                                if (_.get(data, 'zoho.services', null) !== null) {
                                  _.set(applicant, 'zoho.services', _.get(data, 'zoho.services'));
                                }

                                Auth.zohoLogin();
                                AonApplicationService.saveApplication(applicant);

                                return this;
                            });
                        }
                    })
                );
            }

            sendRetentionToZoho(leadId, retention_data, applicant, product) {
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}`, {
                        type: 'retention_to_zoho',
                        retention_data: retention_data,
                        applicant: sanitizeApplicantData(applicant),
                        product: product
                    })
                );
            }

            sendNeedsAnalysisToZoho(leadId, applicant) {
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}`, {
                        type: 'send_to_zoho',
                        is_compare: true,
                        applicant: sanitizeApplicantData(applicant),
                    })
                );
            }

            sendQuoteToZoho(leadId, applicant, product, suppress_opportunity_note = true) {
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}`, {
                        type: 'send_to_zoho',
                        is_quote: true,
                        suppress_opportunity_note,
                        applicant: sanitizeApplicantData(applicant),
                        product: product.selectedPrice,
                        direct_debit_discount: _.get(product, 'apply_direct_debit_discount', false),
                    })
                );
            }

            saveServicesToZoho(leadId, selectedServices) {
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}/services`, selectedServices)
                );
            }

            setStage(leadId, stage) {
                return this.wrapApiCall(
                    AonApi.post(`zoho/${leadId}/stage`, {stage})
                );
            }

            getStage(leadId) {
                return this.wrapApiCall(
                    AonApi.get(`zoho/${leadId}/stage`).then(response => response.data)
                );
            }

        }

        return new ZohoService();
    });
}
;



// WEBPACK FOOTER //
// ./src/services/zoho-service.js